/* eslint-disable handle-callback-err */
/*

  Funkce pro logování chyb.
  error - error zpráva
  logProduction - zda má logovat na produkci.

  logProduction = false -> na vývoji loguje do console pod warningem (dá se filtrovat); na produkci se neloguje
  logProduction = true -> na produkci loguje chybu přímo do Sentry

  V případě nutnosti logování chyb na produkci do konzole stačí změnit hodnotu Raven (Sentry object) na '' (Raven = '';)

  Zda se script nachází na produkci určuje podle toho, zda zná Raven proměnnou (Sentry object) - initializuje se v hlavičce

  **
    PŘÍKLAD S VLASTNÍM VOLÁNÍM
  **

  logger('Selector not found.', true);

  **
    PŘÍKLAD S TRY/CATCH
  **

  try {
    …
  } catch(e) {
    logger(e);
  };

*/

export default function(error, logProduction = false) {
  let production = (typeof Sentry === 'object');

  if (production && logProduction) {
    console.warn(error);

    window.Sentry.onLoad(function() {
      // Use whatever Sentry.* function you want
      window.Sentry.captureException(error);
    });
    window.Sentry.forceLoad();
  }
}
